import React  from 'react';
import Popup from '../popups/popup';
import I18n from 'lib/i18n/i18n';
import { isMobile, imageUrl } from 'helpers/ApplicationHelper';
import { chatBotJBSaveLog } from 'actions/item';
import { connect } from "react-redux";

class PopupFaq extends Popup {
    static initPopup(props = {}) {
        props.preventLocationBack = true;
        Popup.initPopup.call(this, props);
    }

    title() {
        return I18n.getString(`header::faqs::title::${isMobile() ? 'mobile' : 'desktop'}`);
    }

    _onPopupClose() {
        const {
            isJB,
            itemId,
            JBcuiVersion
        } = this.props;

        if (isJB) {
            chatBotJBSaveLog(itemId, {
                key: 'jb_cui_faq_closed',
                version: JBcuiVersion,
                item_id: itemId,
                type: 'faq_button',
                text: 'FAQ JB popup is closed'
            }, JBcuiVersion);
        }
    }

    imagesContent(faq) {
        return (
            <div className='images-container'>
                {(() => {
                   let imagesJSX = [],
                        blnMobile = isMobile();
                   let images = blnMobile ? (faq.mobileImages ? faq.mobileImages : faq.images): faq.images;
                    for (let j = 0; j < (blnMobile ? images.length : 1); j += 2) {
                        imagesJSX.push((
                            <div key={j} className='images-row'>
                                {
                                    (blnMobile ? images.slice(j, j + 2) : images).map((img, idx) => (
                                        <img
                                            key={j + idx}
                                            src={imageUrl(`common/logos/${img}`)}
                                            className={ img.toLowerCase().substring(0, img.indexOf('.')) }
                                        />
                                    ))
                                }
                            </div>
                        ))
                    }
                    return imagesJSX;
                })()}
            </div>
        )
    }

    tableContent(faq) {
        return (
            <React.Fragment>
            <p>{faq.topText}</p><br/>
            <table>
                <thead>
                    <tr>
                        {
                            Object.keys(faq.table.header).map((key, idx) => (
                                <th key={key} className={idx === 0 ? 'align-left' : ''}>{faq.table.header[key]}</th>
                            ))
                        }
                    </tr>
                </thead>
                <tbody>
                {
                    Object.keys(faq.table.body).map(key => (
                        <tr key={key}>
                            {
                                Object.keys(faq.table.body[key]).map((inKey, idx) => (
                                    <td key={inKey}
                                        className={idx === 0 ? 'align-left' : ''} dangerouslySetInnerHTML={{__html:faq.table.body[key][inKey]}}/>
                                ))
                            }
                        </tr>
                    ))
                }
                </tbody>
            </table><br/>
            </React.Fragment>
        )
    }

    content() {
        const { isJB } = this.props;
        const faqs = I18n.getString(`header::faqs::${ isJB ? 'contentJB' : 'content' }`);

        return (
            <div className='faq-container'>
                {
                    Object.keys(faqs).map(i => {
                        return (
                            <div className='faq' key={i}>
                                <div className='faq-text question'>
                                    <span className='bold'>Q</span><p className='bold'>{faqs[i].q}</p>
                                </div>
                                <div className='faq-text answer'>
                                    <span className='bold'>A</span>
                                    {
                                        (() => {
                                            // Here "a" stands for "answer" and "q" for "question"
                                            if (typeof faqs[i].a === 'string') {
                                                // It's a plain string
                                                return <p>{faqs[i].a}</p>;
                                            } else if (typeof faqs[i].a === 'object' && faqs[i].a.length > 0) {
                                                // It's an array
                                                return faqs[i].a.map((tag, i) => {
                                                    if (tag['p']) {
                                                        return <p key={i}>{tag['p']}</p>
                                                    }
                                                    if (tag['ul']) {
                                                        return <ul key={i} style={{listStyleType: tag['type'] || '' }} >{
                                                            (() => {
                                                                return tag['ul'].map((li, idx) => <li key={idx} dangerouslySetInnerHTML={{__html:li}}/>)
                                                            })()
                                                        } </ul>
                                                    }
                                                    // ...add another tag you wish to use
                                                })
                                            }
                                        })()
                                    }
                                    {
                                        faqs[i].table ? this.tableContent(faqs[i]) : null
                                    }
                                    {
                                        faqs[i].feeCommentBottom ? <p dangerouslySetInnerHTML={{__html:faqs[i].feeCommentBottom}}/> : null
                                    }
                                </div>
                                {
                                    faqs[i].images ? this.imagesContent(faqs[i]) : null
                                }
                            </div>
                        )
                    })
                }
            </div>
        );
    }
}

PopupFaq.defaultProps = {
    popupClassName: 'popup-faq',
    single: true,
    modal: true,
    onPopupClose: function() {
        this._onPopupClose();
    }
};

const mapStateToProps = ({
    Item,
    ChatBot,
    Experiments,
    PendingJewelryBox
}) => {
    return {
        JBcuiVersion: Experiments ? ChatBot.conversationFlow.jewelryBox[Experiments && Experiments.jb_cui && Experiments.jb_cui.status && Experiments.jb_cui.variant === 'true' ? 1 : 0][0].version : null,
        itemId: Item && Item.id || PendingJewelryBox && PendingJewelryBox.id,
    }
};

export default connect(mapStateToProps)(PopupFaq);
